/**
 * Country is a two letter ISO 3166 code
 *
 * [More info can be found here](https://en.wikipedia.org/wiki/ISO_3166-1)
 */
enum Country {
  CH = 'CH',
  DE = 'DE',
  US = 'US',
}

export { Country }
